import { Box } from "@mui/material";
import { Typography, palette } from "@powerdiary/components-library/lib";
import { getUsersTimeZone } from "utils/timeZoneUtils";

import styles from "./CalendarLegend.module.css";

export default function CalendarLegend() {
    return (
        <Box className={styles.wrapper} data-test-id="section_calendar_legend">
            <Box className={styles.legendItem}>
                <Box sx={{ backgroundColor: palette.dusk["200"] }} className={styles.legendBox} />
                <Typography variant="paragraphMediumSemiBold">Morning</Typography>
            </Box>
            <Box className={styles.legendItem}>
                <Box sx={{ backgroundColor: palette.sunflower["300"] }} className={styles.legendBox} />
                <Typography variant="paragraphMediumSemiBold">Afternoon</Typography>
            </Box>
            <Box className={styles.legendItem}>
                <Box sx={{ backgroundColor: palette.twilight["100"] }} className={styles.legendBox} />
                <Typography variant="paragraphMediumSemiBold">Evening</Typography>
            </Box>
            <Typography
                variant="paragraphMediumSemiBold"
                className={styles.timezoneText}
                data-test-id="text_user_timezone"
                sx={(theme) => ({
                    [theme.breakpoints.down("sm")]: {
                        marginLeft: "0 !important",
                    },
                })}
            >
                All times are in {getUsersTimeZone()}
            </Typography>
        </Box>
    );
}
